import { render, staticRenderFns } from "./CustomerPerformanceAccrual.vue?vue&type=template&id=c471e988&"
import script from "./CustomerPerformanceAccrual.vue?vue&type=script&lang=js&"
export * from "./CustomerPerformanceAccrual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports